import { render, staticRenderFns } from "./barHeader.vue?vue&type=template&id=48580cda&scoped=true&"
import script from "./barHeader.vue?vue&type=script&lang=js&"
export * from "./barHeader.vue?vue&type=script&lang=js&"
import style0 from "./barHeader.vue?vue&type=style&index=0&id=48580cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48580cda",
  null
  
)

component.options.__file = "barHeader.vue"
export default component.exports